"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceNotification = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var utils_1 = require("./utils");
var Info_1 = __importDefault(require("@mui/icons-material/Info"));
exports.MaintenanceNotification = function (_a) {
    var maintenance = _a.maintenance, onDontShowAgain = _a.onDontShowAgain, colors = _a.colors, dontShowLabel = _a.dontShowLabel;
    var _b = react_1.useState(true), open = _b[0], setOpen = _b[1];
    var handleClose = function () { return setOpen(false); };
    var handleDontShowAgain = function () {
        handleClose();
        onDontShowAgain();
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.Snackbar, { open: open, autoHideDuration: 15000, onClose: function () { }, anchorOrigin: { vertical: 'top', horizontal: 'center' } },
            react_1.default.createElement(material_1.Alert, { onClose: handleClose, severity: "info", sx: {
                    width: '100%',
                    alignItems: 'center',
                    border: "0.6px solid " + colors.primary,
                    color: colors.text,
                    backgroundColor: colors.secondary
                }, icon: react_1.default.createElement(Info_1.default, { sx: { color: colors.icon || colors.text } }) },
                utils_1.interpolate(maintenance.currentState.notificationsDescription, __assign(__assign({}, maintenance.currentState), { notificationsStartDate: utils_1.formatDate(maintenance.currentState.notificationsStartDate), notificationsEndDate: utils_1.formatDate(maintenance.currentState.notificationsEndDate), downtimeStartDate: utils_1.formatDate(maintenance.currentState.downtimeStartDate), downtimeEndDate: utils_1.formatDate(maintenance.currentState.downtimeEndDate) })),
                react_1.default.createElement("br", null),
                react_1.default.createElement(material_1.Button, { onClick: handleDontShowAgain, variant: "contained", size: "small", style: {
                        color: colors.buttonText || colors.text,
                        backgroundColor: colors.primary,
                        marginTop: '1em'
                    } }, dontShowLabel)))));
};
